import * as React from 'react'

import Svg, { G, Path, Defs, ClipPath } from 'react-native-svg'

import { IconProps } from '../icons'

const EyeOutlined = ({ size = 24, color = '#000', ...props }: IconProps) => (
  <Svg
    width={`${size}px`}
    height={`${size}px`}
    viewBox="0 0 24 24"
    fill={color}
    {...props}
  >
    <G clipPath="url(#a)">
      <Path
        d="M20.74 9.9C18.82 7 15.62 5.1 12 5.1S5.17 7 3.26 9.9c-.34.51-.64 1.05-.89 1.61-.12.26-.12.56 0 .82.25.56.56 1.1.89 1.61 1.92 2.9 5.12 4.8 8.74 4.8s6.83-1.9 8.74-4.8c.34-.51.64-1.05.89-1.61.12-.26.12-.56 0-.82-.25-.56-.56-1.1-.89-1.61ZM12 17.11c-3.33 0-6.24-1.91-7.79-4.72a.98.98 0 0 1 0-.94C5.77 8.63 8.67 6.73 12 6.73s6.24 1.91 7.79 4.72c.16.29.16.65 0 .94-1.56 2.82-4.46 4.72-7.79 4.72Z"
        fill={color}
      />
      <Path
        d="M12 15.86c-2.13 0-3.86-1.73-3.86-3.86S9.87 8.14 12 8.14s3.86 1.73 3.86 3.86-1.73 3.86-3.86 3.86Zm0-6.12c-1.25 0-2.26 1.01-2.26 2.26 0 1.25 1.01 2.26 2.26 2.26 1.25 0 2.26-1.01 2.26-2.26 0-1.25-1.01-2.26-2.26-2.26Z"
        fill={color}
      />
    </G>
    <Defs>
      <ClipPath id="a">
        <Path fill="#fff" d="M0 0h24v24H0z" />
      </ClipPath>
    </Defs>
  </Svg>
)

export default EyeOutlined
